import { Injectable, Type } from "@angular/core";
import { Routes } from "@angular/router";
import { DynamicRoute, IDynamicRoutesProvider } from "core";
import { TEST_DESCRIBE } from "../constants";
import { AccessibilityTestpage } from "../accessibility-testpage/accessibility-testpage";
import { TestPage } from "../test-page/test-page";

@Injectable({ providedIn: 'root' })
export class TestRoutesProvider extends IDynamicRoutesProvider {

    override componentMap: Record<string, Type<any>> = {
        'test': TestPage,
        'accessibility': AccessibilityTestpage,
    };

    // deve corrispondere all'id nel json della chiamate delle rotte
    override describe(): String {
        return 'test';
    }

    override evaluate(dynamicRoute: DynamicRoute[]): Routes {
        return this.buildRoutes(dynamicRoute, TEST_DESCRIBE);
    }
    // dynamicRoute example:
    // {
    //     "id": "test",
    //     "path": "test",
    //     "children": [
    //         {
    //             "id": "page",
    //             "path": "",
    //             "children": []
    //         },
    //         {
    //             "id": "accessibility",
    //             "path": "accessibility",
    //             "children": []
    //         }
    //     ]
    // }
}